import React, { Component } from 'react';
import Heading from "../elements/Heading";
import globals from "../globals";

class SecondHeading extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            items: []
        };
    }

    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState(this.props.data);
        }
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }
    
    render() {
        const ListItems = () => {
            const Items = this.state.items.map((item, key) => {
                return (
                    <div key={key} className="flex-column">
                        <img src={item.image} height="60" alt={item.title} />
                        <h3 dangerouslySetInnerHTML={{__html: item.title}} />
                        <p>{item.description}</p>
                    </div>
                );
            });

            return (
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 col-xs-12 centered">
                        <div className="flex-row">
                            {Items}
                        </div>
                    </div>
                </div>
            );  
        };

        const LeadCopy = this.state.leadCopy.map((item, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{__html: item}} />
            );
        });
        
        return (
            <section className={`second-heading ${this.props.className ? this.props.className : ''}`}>
                <div ref={el => this.content = el}>
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 col-xs-12 centered">
                            <Heading title={this.state.title} subTitle={this.state.subTitle} />
                            {LeadCopy}
                        </div>
                    </div>
                    { (this.state.items.length > 0 ? ListItems() : '') }
                    {this.props.children}
                </div>
            </section>
        );
    }
    
}

export default SecondHeading;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/SecondHeading.js